import React from "react";
import InternalDrawer from "../FormInformation/InternalDrawer";
import { Templates } from "pages/Communication/Components/Templates/Templates";

const NotificationTemplate = (props) => {
    const formik = props;
  return (
   <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
          {/* <div className="info_title d-flex justify-content-between align-items-center"> */}
            {/* <div>
              <h2>Templates</h2>
              <p>Please select a form</p>
            </div> */}
                {/* <div className="info_title">
                        <h2>Team Notification</h2>
                      
                      </div> */}
             <Templates componentCalled={'form'} formik={formik}/>
            {/* <Button
              onClick={navigateIntoCreateFormHandler}
              size="md"
              variant="primary"
            >
              Create New Form Template
            </Button> */}
          {/* </div> */}
          {/* <div className="classTap_content">
            <FormTemplates
              formik={formik}
              updateTemplateHandler={updateTemplateHandler}
              deleteTemplateConfirmHandler={deleteTemplateConfirmHandler}
              setSelectedTemplate={setSelectedTemplate}
              formTemplates={formTemplates}
              formNames={formNames}
              getForms={getForms}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              loading={getFormsLoading}
              onDuplicateTemplate={onDuplicateTemplate}
            />
          </div> */}
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik} />
      </div>
      {/* <AlertDialog
        open={confirmDelete}
        handleClose={() => setConfirmDelete(false)}
        onDecline={() => {
          setConfirmDelete(false);
        }}
        onAccept={deleteTemplateHandler}
        loading={deleteTemplateLoading}
        title={"Are you sure?"}
        description={`Do you want to delete this template?`}
      /> */}
      {/* <AlertDialog
        open={confirmNavigation}
        handleClose={() => setConfirmNavigation(false)}
        onDecline={() => {
          setConfirmNavigation(false);
        }}
        onAccept={backToTemplatesHandler}
        title={"Are you sure?"}
        description={`Do you want to discard the changes you made?`}
      /> */}
      {/* <MyModal
        className={"new-charge-modal"}
        open={openCreateFormModal}
        onClose={() => {
          setConfirmNavigation(true);
        }}
      >
        <NewQuestionForm
          formik={formik}
          selectedTemplate={selectedTemplate}
          type={formTemplateTabType}
          handleCreateAndUpdateSuccess={handleCreateAndUpdateSuccess}
        />
      </MyModal> */}
      {/* <MainModal
        open={confirmOpen.open}
        onDecline={onCloseConfirmDialog}
        onAccept={() => {
          duplicateTemplateHandler();
        }}
        loading={confirmOpen.isLoading}
        title={"Are you sure?"}
        inputField={true}
        inputFieldLabel={"Template Name"}
        inputFieldName={"template_name"}
        inputFieldValue={duplicateTemplateName}
        onChange={(e) => {
          setDuplicateTemplateName(e.target.value);
        }}
      /> */}
    </div>
  );
};

export default NotificationTemplate;